/*
 * JAUNE お気に入り機能
 * ------------------------------------------------------------
 * - 商品ページの「保存する」ボタン（snippets/jaune-favorite-button.liquid）
 * - お気に入り一覧ページ（sections/jaune-favorites.liquid）
 * どちらもこの1ファイルで動く。装飾は assets/jaune.css（38番）。
 *
 * データは Supabase の RPC 関数を叩く：
 *   add_favorite / remove_favorite / get_favorites / merge_guest_favorites
 * publishable キーはブラウザ埋め込み前提の公開キー。
 * 未ログインは localStorage、ログイン中はアカウント（customer_id）に保存。
 */
(function () {
  'use strict';
  if (window.__jauneFavInit) return;
  window.__jauneFavInit = true;

  var SUPABASE_URL = 'https://ihmsqlyhsrqzwfsblndj.supabase.co';
  var SUPABASE_KEY = 'sb_publishable_NpntE5Ys14nFi_YKbKydFA_We7WH5Wo';

  var LS_ITEMS = 'jaune_fav_items';     // [{id, handle}]
  var LS_SESSION = 'jaune_fav_session'; // ゲスト識別ID
  var LS_MERGED = 'jaune_fav_merged_for'; // マージ済みの customer_id

  /* ---------- 識別子 ---------- */

  function getCustomerId() {
    var c = (window.JauneFav && window.JauneFav.customerId) || null;
    if (c === 'null' || c === '' || c === 0 || c === '0') c = null;
    return c ? String(c) : null;
  }

  function getSessionId() {
    var s = null;
    try { s = localStorage.getItem(LS_SESSION); } catch (e) {}
    if (!s) {
      s = (window.crypto && crypto.randomUUID)
        ? crypto.randomUUID()
        : 'sid-' + Date.now() + '-' + Math.random().toString(16).slice(2);
      try { localStorage.setItem(LS_SESSION, s); } catch (e) {}
    }
    return s;
  }

  var customerId = getCustomerId();
  var sessionId = getSessionId();

  /* ---------- localStorage ---------- */

  function readLocal() {
    try { return JSON.parse(localStorage.getItem(LS_ITEMS) || '[]'); }
    catch (e) { return []; }
  }
  function writeLocal(items) {
    try { localStorage.setItem(LS_ITEMS, JSON.stringify(items)); } catch (e) {}
  }
  function localHas(id) {
    return readLocal().some(function (it) { return String(it.id) === String(id); });
  }
  function localAdd(id, handle) {
    var items = readLocal();
    if (!items.some(function (it) { return String(it.id) === String(id); })) {
      items.unshift({ id: String(id), handle: handle });
      writeLocal(items);
    }
  }
  function localRemove(id) {
    writeLocal(readLocal().filter(function (it) { return String(it.id) !== String(id); }));
  }

  /* ---------- Supabase RPC ---------- */

  function rpc(fn, body) {
    return fetch(SUPABASE_URL + '/rest/v1/rpc/' + fn, {
      method: 'POST',
      headers: {
        'apikey': SUPABASE_KEY,
        'Authorization': 'Bearer ' + SUPABASE_KEY,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body || {})
    });
  }

  function serverAdd(id, handle) {
    return rpc('add_favorite', {
      p_product_id: Number(id),
      p_product_handle: handle || '',
      p_session_id: sessionId,
      p_customer_id: customerId ? Number(customerId) : null
    });
  }
  function serverRemove(id) {
    return rpc('remove_favorite', {
      p_product_id: Number(id),
      p_session_id: sessionId,
      p_customer_id: customerId ? Number(customerId) : null
    });
  }
  function serverList() {
    return rpc('get_favorites', {
      p_session_id: customerId ? null : sessionId,
      p_customer_id: customerId ? Number(customerId) : null
    })
      .then(function (r) { return r.ok ? r.json() : []; })
      .catch(function () { return []; });
  }
  function maybeMerge() {
    if (!customerId) return Promise.resolve();
    var mergedFor = null;
    try { mergedFor = localStorage.getItem(LS_MERGED); } catch (e) {}
    if (mergedFor === String(customerId)) return Promise.resolve();
    return rpc('merge_guest_favorites', {
      p_session_id: sessionId,
      p_customer_id: Number(customerId)
    })
      .then(function () {
        try { localStorage.setItem(LS_MERGED, String(customerId)); } catch (e) {}
      })
      .catch(function () {});
  }

  /* ---------- ボタン ---------- */

  /* 画面下に数秒だけ出る通知バー */
  function toast(msg) {
    var el = document.querySelector('.jaune-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'jaune-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.remove('is-visible');
    void el.offsetWidth; // アニメーションを再生し直す
    el.classList.add('is-visible');
    clearTimeout(el.__jauneToastTimer);
    el.__jauneToastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2600);
  }

  function setButtonState(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-active', on);
    var off = btn.querySelector('[data-jaune-fav-label-off]');
    var onl = btn.querySelector('[data-jaune-fav-label-on]');
    if (off) off.hidden = on;
    if (onl) onl.hidden = !on;
  }

  function wireButtons(favSet) {
    document.querySelectorAll('[data-jaune-fav]').forEach(function (btn) {
      if (btn.__jauneWired) return;
      btn.__jauneWired = true;

      var id = btn.getAttribute('data-product-id');
      var handle = btn.getAttribute('data-product-handle');
      setButtonState(btn, favSet.has(String(id)) || localHas(id));

      btn.addEventListener('click', function () {
        var activate = btn.getAttribute('aria-pressed') !== 'true';
        setButtonState(btn, activate); // 楽観的に反映
        btn.disabled = true;

        if (activate) { localAdd(id, handle); } else { localRemove(id); }
        toast(activate ? '保存しました' : '保存を解除しました');
        var op = activate ? serverAdd(id, handle) : serverRemove(id);

        op
          .then(function (r) { if (r && !r.ok) throw new Error('rpc'); })
          .catch(function () {
            setButtonState(btn, !activate); // 失敗したら戻す
            if (activate) { localRemove(id); } else { localAdd(id, handle); }
            toast('通信に失敗しました。時間をおいて再度お試しください');
          })
          .then(function () { btn.disabled = false; });
      });
    });
  }

  /* ---------- 一覧ページ ---------- */

  function money(cents) {
    return '¥' + Math.round((cents || 0) / 100).toLocaleString('ja-JP');
  }

  function renderList(listEl, emptyEl, items) {
    listEl.innerHTML = '';
    if (!items.length) {
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    items.forEach(function (it) {
      var handle = it.handle || it.product_handle;
      var id = it.id || it.product_id;
      if (!handle) return;

      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var li = document.createElement('li');
          li.className = 'jaune-favs__item';

          var img = p.featured_image
            ? '<img class="jaune-favs__img" src="' + p.featured_image + '&width=600" alt="" loading="lazy">'
            : '<span class="jaune-favs__img jaune-favs__img--empty"></span>';
          var sold = p.available ? '' : '<span class="jaune-favs__sold">SOLD</span>';

          li.innerHTML =
            '<a class="jaune-favs__link" href="/products/' + handle + '">' +
              '<span class="jaune-favs__media">' + img + sold + '</span>' +
              '<span class="jaune-favs__name"></span>' +
              '<span class="jaune-favs__price"></span>' +
            '</a>' +
            '<button type="button" class="jaune-favs__remove" data-remove="' + id + '">保存を解除</button>';

          li.querySelector('.jaune-favs__name').textContent = p.title || '';
          li.querySelector('.jaune-favs__price').textContent = money(p.price);
          listEl.appendChild(li);
        })
        .catch(function () {});
    });
  }

  function wireListRemovals(listEl, emptyEl) {
    listEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-remove]');
      if (!b) return;
      var id = b.getAttribute('data-remove');
      localRemove(id);
      serverRemove(id).catch(function () {});
      toast('保存を解除しました');
      var li = b.closest('.jaune-favs__item');
      if (li) li.remove();
      if (!listEl.children.length && emptyEl) emptyEl.hidden = false;
    });
  }

  /* ---------- 初期化 ---------- */

  function init() {
    var listEl = document.querySelector('[data-jaune-fav-list]');
    var emptyEl = document.querySelector('[data-jaune-fav-empty]');

    maybeMerge()
      .then(function () { return customerId ? serverList() : Promise.resolve(null); })
      .then(function (serverItems) {
        var favSet = new Set();

        if (serverItems && serverItems.length) {
          serverItems.forEach(function (row) { favSet.add(String(row.product_id)); });
          if (customerId) {
            writeLocal(serverItems.map(function (row) {
              return { id: String(row.product_id), handle: row.product_handle };
            }));
          }
        }

        wireButtons(favSet);

        if (listEl) {
          var items = (customerId && serverItems)
            ? serverItems.map(function (row) {
                return { id: row.product_id, handle: row.product_handle };
              })
            : readLocal();
          renderList(listEl, emptyEl, items);
          wireListRemovals(listEl, emptyEl);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
